// Channel metadata — label + brand color + lucide icon name — shared by the
// Avatar channel badge, the inbox channel-filter chips, and conversation rows.
import type { Channel } from "./types";

export interface ChannelMeta {
  label: string;
  color: string;
  /** lucide-react icon name (imported by the consuming component). */
  icon: string;
}

export const CHANNELS: Record<Channel, ChannelMeta> = {
  feedback: { label: "Feedback", color: "#4f46e5", icon: "MessageSquareDot" },
  chat: { label: "Chat", color: "#0284c7", icon: "MessageCircle" },
  email: { label: "E-Mail", color: "#0d9488", icon: "Mail" },
  whatsapp: { label: "WhatsApp", color: "#25D366", icon: "MessageCircleMore" },
  instagram: { label: "Instagram", color: "#db2777", icon: "Instagram" },
  sms: { label: "SMS", color: "#f59e0b", icon: "Smartphone" },
  slack: { label: "Slack", color: "#7c3aed", icon: "Slack" },
};

export const CHANNEL_ORDER: Channel[] = [
  "feedback",
  "chat",
  "email",
  "whatsapp",
  "instagram",
  "sms",
  "slack",
];
